import {
  BaseTable,
  Card,
  Loading,
  PaginationData,
  Button,
  TableNumber,
  PermissionLink,
  ActionButton,
  Select
} from "components"
import { useNavigate } from "react-router-dom"
import { useEffect, useState } from "react"
import { PaginationState } from "types"
import { FilterFormTypes } from "../types/RegisterTypes"
import moment from "moment"
import { useProjectList } from "../utils/useProjectList"
import { APPROVE_STATUS, PROJECT_STATUS, getProjectStatusLabel, PROJECT_STATUS_OPTIONS } from "../utils/projectTypeOption"
import { IoSendSharp } from "react-icons/io5"
import { ModalDeleteProject } from "../components/ModalDelete"
import { useToggle } from "utils"

export function DateRangeTab(): JSX.Element {
  const navigate = useNavigate()
  const modalDelete = useToggle(false);
  const [selectedItem, setSelectedItem] = useState<any>(null);
  const [filter, setFilter] = useState<FilterFormTypes>({
    status_project: Number(PROJECT_STATUS.PENDING),
    limit: 10,
    page: 1,
  })

  const default_pagination_value = {
    total: 0,
    page: 1,
    limit: 10,
    pages: 1,
    keyword: "",
  }

  const [pagination, setPagination] = useState<PaginationState>(
    default_pagination_value
  )

  const { data, isLoading, refetch, paginationData } = useProjectList({
    size: pagination.total || 0,
    page: pagination.page || 10,
    limit: pagination.limit || 10,
    status_project: filter.status_project
  })

  useEffect(() => {
      refetch()
    //eslint-disable-next-line
  }, [pagination.page, pagination.limit])

  const handleClick = () =>{
    refetch()
  } 

  return (
    <section className="m-5">
      <section>
        <Card>
          <Card.Body>
            <section className="flex items-center justify-between">
              <div className="flex items-center gap-2">
                <div className="label-text font-bold uppercase whitespace-nowrap">
                  STATUS PROJECT
                </div>
                <div className="w-[200px]">
                  <Select
                    options={PROJECT_STATUS_OPTIONS}
                    value={PROJECT_STATUS_OPTIONS.find(opt => Number(opt.value) === filter.status_project) ?? null}
                    onChange={(selected) =>
                      setFilter({
                        ...filter,
                        status_project: selected ? Number(selected.value) : undefined
                      })
                    }
                  />
                </div>
                <Button className="bg-primary" onClick={handleClick}>
                  Submit
                </Button>
              </div>

              <div className="flex gap-2">
                <Button className="bg-primary"
                  permission="ST10"
                  onClick={() => navigate("/project/approve-project")}
                >
                  APPROVE PROJECT
                </Button>
                <Button className="bg-primary"
                  permission="SUBSCRIBED"
                  onClick={() => navigate("/project/create")}
                >
                  CREATE
                </Button>
              </div>
            </section>
          </Card.Body>
        </Card>
      </section>

      <section>
        <Card>
          <Card.Body>
            <div className="overflow-x-auto max-h-[calc(100vh-400px)]">
              <BaseTable>
                <thead className="top-0 z-1 !bg-black !text-white">
                  <tr>
                    <th>NO</th>
                    <th>ID#</th>
                    <th>NAME</th>
                    <th>DATE</th>
                    <th>STATUS</th>
                    <th>START</th>
                    <th>ACTION</th>
                  </tr>
                </thead>
                <tbody>
                  {isLoading || data?.length === 0 ? (
                    <tr>
                      <td colSpan={13}>
                        <Loading
                          loading={isLoading}
                          errorText="No data available"
                        />
                      </td>
                    </tr>
                  ) : (
                      data.map((item,index) => {

                        return(
                            <tr key={index}>
                                <td>
                                    {TableNumber({
                                        pageCurrent: paginationData?.page,
                                        dataLength: paginationData?.size!,
                                        index: index,
                                        limit: paginationData?.limit ?? 10,
                                        totalData: paginationData?.total
                                    })}
                                </td>
                                <td>{item.trx_code}</td>
                                <td>{item.project_name}</td>
                                <td className="text-center">{item.transaction_date ? moment(item.transaction_date).format('DD/MM/YYYY') : ''}</td>
                                <td className="text-center">{item.status_project ? getProjectStatusLabel(String(item.status_project)) : ""}</td>
                                <td className="text-center">{item.start_date ? moment(item.start_date).format('DD/MM/YYYY'): ''}</td>
                                <td className="text-center flex justify-around">
                                    <PermissionLink
                                      permission={"PR01"}
                                      to={`/project/${item.approve_status && item.approve_status.toString() === APPROVE_STATUS.PENDING?'edit':'edit'}/${item.project_id}`}
                                      className="mt-1"
                                    >
                                      <IoSendSharp />
                                    </PermissionLink>

                                    {item.approve_status && item.approve_status.toString() === APPROVE_STATUS.PENDING ? (
                                      <ActionButton.Delete permission="SR014" color='red' onClick={()=>{
                                        setSelectedItem(item)
                                        modalDelete.toggle()
                                      }} />
                                    ) : null}
                                </td>
                            </tr>
                        )
                    })
                  )}

                  {selectedItem !== null && (
                    <ModalDeleteProject
                      data={selectedItem}
                      modalState={modalDelete}
                      onSuccess={refetch}
                    />
                  )}
                  

                </tbody>
              </BaseTable>
              <div className="mt-3">
                <PaginationData
                  data={data}
                  pagination={paginationData}
                  setPagination={setPagination}
                />
              </div>
            </div>
          </Card.Body>
        </Card>
      </section>
    </section>
  )
}
